import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { inject, observer } from 'mobx-react'
import Image from 'next/image'
import styled, { ThemeProvider } from 'styled-components'

import { buildAdminTheme } from '/styles/theme'

const RenderNav = inject('store')(
  observer(() => {
    return (
      <Navbar>
        <NavbarContent>
          <NavbarHomeCenter>
            <Image
              src="/connect/logo-dark.png"
              height="100"
              width="100"
              alt="Chalice Connect logo"
            />
          </NavbarHomeCenter>
        </NavbarContent>
      </Navbar>
    )
  })
)

const SignupFooter = inject('store')(
  observer(({ store }) => {
    if (!store.siteData) {
      return null
    }
    return (
      <Footer>
        <Link passHref href="/privacy-policy/">
          <a>Privacy Policy</a>
        </Link>
        <Link passHref href="/terms-of-service/">
          <a>Terms of Service</a>
        </Link>
      </Footer>
    )
  })
)

const ConnectLayout = ({ siteData, children }) => {
  const theme = buildAdminTheme(siteData)
  return (
    <ThemeProvider theme={theme}>
      <div className="signup-page">
        <Section>
          <RenderNav />
          <Content>
            <ContentWrapper>{children}</ContentWrapper>
          </Content>
          <SignupFooter />
        </Section>
      </div>
    </ThemeProvider>
  )
}

ConnectLayout.proptypes = {
  children: PropTypes.object
}

export default ConnectLayout

const Navbar = styled.nav`
  background-color: #fff;
  position: relative;
  z-index: 1040;
  top: 0;
  width: 100%;
  transition: all 0.25s;
  flex: 0 1 auto;
`

const NavbarContent = styled.div`
  align-items: center;
  background-color: transparent;
  border: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
  flex: 1 0 auto;
`

const NavbarHomeCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Section = styled.section`
  padding-top: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const Content = styled.div`
  padding-top: 0;
  flex: 1 0 auto;
`

const ContentWrapper = styled.div`
  padding: 20px;
`

const Footer = styled.div`
  flex: 0 1 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0;
  padding: 10px;
  border: ${(props) => props.theme.colors.adminBorder} solid 0;
  border-top-width: 1px;
  font-size: ${(props) => props.theme.fontSizes.fontSizes};

  a {
    padding: 0 20px;
    color: ${(props) => props.theme.colors.black};
  }
`
